import { loadScript } from './functions.ts';

/**
 * loads a script and executes a callback
 * @param {string} url
 * @param {function} done
 */
window.loadScriptLegacy = (url, done = () => {}) => {
    const js = document.createElement('script');
    // done = typeof done === 'undefined' ? () => {} : done;
    js.src = url;
    js.onload = () => done();
    js.onerror = () => done(new Error(`Failed to load script ${url}`));
    document.head.appendChild(js);
};

/**
 * this is called after polyfill.io script fetching is finished.
 */
window.polyfillsLoaded = () => {
    // load object-fit polyfill
    if (!('objectFit' in document.documentElement.style)) {
        loadScript('https://cdnjs.cloudflare.com/ajax/libs/object-fit-images/3.2.4/ofi.min.js').then(() => {
            /* eslint-disable-next-line no-undef */
            objectFitImages();
        });
    }

    // more polyfills for ie11
    if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
        document.createElement('picture');
        loadScript('https://cdn.rawgit.com/scottjehl/picturefill/3.0.2/dist/picturefill.min.js');
        loadScript('https://cdn.jsdelivr.net/npm/ie11-custom-properties@4.1.0/ie11CustomProperties.min.js');
    }

    window.browserUpdate({
        required: {
            c: -3,
            f: -3,
            s: -2,
            o: -3,
            o_a: -3,
            y: -3,
            v: -2,
            uc: -2,
            ios: -2,
            i: 0,
        },
        l: window.lang,
        insecure: true,
        reminder: 0,
        reminderClosed: 1,
    });
};

if (!window.Promise || !window.fetch || !window.Symbol) {
    if (!('fetch' in window)) { // fetch polyfill
        window.loadScriptLegacy('https://cdn.jsdelivr.net/npm/whatwg-fetch@3.0.0/dist/fetch.umd.min.js');
    }

    // load polyfills and call callback
    window.loadScriptLegacy('https://polyfill.io/v3/polyfill.min.js?flags=gated&callback=polyfillsLoaded');
}
